import { makeStyles } from 'tss-react/mui';
import { fontWeights, spacing, colors } from '../../styles/jss/variables';
const useStyles = makeStyles()((theme) => ({
    body: Object.assign(Object.assign({}, theme.typography.small_bold), { marginBottom: spacing.large, textAlign: 'center', color: theme.isFlyingFlowers ? colors.black[700] : undefined, [theme.breakpoints.up('md')]: Object.assign(Object.assign({}, theme.typography.medium_bold), { marginBottom: spacing.xl }), '& p:last-child': {
            marginBottom: 0,
        } }),
    roundButtonLabel: {
        marginTop: 6,
        padding: `0 !important`, // looks like we can safely remove this, let's verify all the cases and remove it while working on removal of "!important" from the codebase
        textAlign: 'center',
        lineHeight: theme.isFlyingFlowers ? '1.25rem' : 'inherit',
    },
    title: Object.assign(Object.assign({}, theme.typography.large_bold), { fontWeight: fontWeights.bold, marginBottom: spacing.medium, textAlign: 'center', color: theme.isFlyingFlowers ? colors.black[700] : undefined, [theme.breakpoints.up('md')]: Object.assign({}, theme.typography.xl_bold) }),
    roundButton: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        margin: `0 ${spacing.medium}`,
    },
    content: {
        display: 'flex',
        justifyContent: 'center',
    },
    container: {
        marginBottom: spacing.small,
        [theme.breakpoints.up('md')]: {
            marginRight: spacing.medium,
        },
    },
    chatLabelMultiline: {
        whiteSpace: 'pre-line',
    },
    chatLabelMultilineDisabled: {
        whiteSpace: 'pre-line',
        color: colors.grey.grey8,
    },
}));
export default useStyles;
